var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.cardClass,attrs:{"active":_vm.isActive},on:{"click":function($event){return _vm.$emit('app-card-click')}}},[_vm._t("header"),_vm._t("body")],2)}
var staticRenderFns = []

export { render, staticRenderFns }